<div class="account-bar" [class.session-expiring]="isAuthenticated && showExpiryWarning()" [class.api-disconnected]="!isApiConnected">
    <a *ngIf="isAuthenticated" class="account-bar-content" href="#" (click)="toggleTenantPanel($event)">
        <i class="fas fa-user"></i> {{ userName }} - {{ tenantName }}
    </a>

    <span *ngIf="isAuthenticated" style="color: #fff; padding: 5px; text-align: center;">
        |
    </span>

    <a *ngIf="isAuthenticated" class="account-bar-content" href="#" (click)="logout($event)">
        <i class="fas fa-door-open"></i> Sign Out
    </a>

    <a *ngIf="!isAuthenticated" class="account-bar-content" href="#" (click)="login($event)">
        <i class="fas fa-door-open"></i> Sign In
    </a>

    <span *ngIf="!isApiConnected" class="session-warning-container api-warning">
        <i class="fas fa-exclamation-triangle"></i>
        <span class="session-warning-text">
            Unable to connect to the API
        </span>
    </span>

    <span *ngIf="isAuthenticated && showExpiryWarning()" class="session-warning-container">
        <i class="fas fa-exclamation-triangle"></i>
        <span class="session-warning-text">
            Your session will expire in {{ tokenExpirySeconds | minutesSeconds }}, please save your work
        </span>
    </span>
</div>

<div class="header-bar">
    <div class="header-bar-content">
        <div class="logo-content">
            <img src="../../../assets/images/marsh-logo-rgb-sky.png" alt="Logo" class="marsh-logo" />
            <span class="app-name">Credi-Link</span>
        </div>

        <nav class="menu-content">
            <ul>
                <li class="menu-item">
                    <a href="/" class="standalone-menu-item">HOME</a>
                </li>

                <li *ngIf="menuPermissions.showDeclaration || false" class="menu-item">
                    <a>DECLARATION</a>

                    <ul class="sub-menu">
                        <li *hasPermission="['Annexure', 'View']">
                            <a href="/annexure">Annexure Listings</a>
                        </li>
                        <li *hasPermission="['Ageing', 'View']">
                            <a href="/ageing">Ageing Listings</a>
                        </li>
                        <li *hasPermission="['Sales', 'View']">
                            <a href="/sales">Sales Listings</a>
                        </li>
                        <li *hasPermission="['Matching', 'View']">
                            <a href="/matching">Matching Analysis</a>
                        </li>

                        <li *hasPermission="['DeclarationReports', 'View']" class="nested-menu-item">
                            <a>General Reports</a>

                            <ul class="nested-sub-menu">
                                <li>
                                    <a href="/ageing-export-parameters">Bulk Ageing Export</a>
                                </li>
                                <li>
                                    <a href="/annexure-export-parameters">Bulk Annexure Report</a>
                                </li>
                                <li>
                                    <a href="/data-status-report-parameters">Data Status Report</a>
                                </li>
                                <li>
                                    <a href="/shared-debtor-by-policy-parameters">Shared Debtor By Policy</a>
                                </li>
                            </ul>
                        </li>

                        <li *hasPermission="['DeclarationReports', 'View']">
                            <a href="/declaration-report-selection">Declaration Reports</a>
                        </li>
                    </ul>
                </li>

                <li *ngIf="menuPermissions.showRenewal || false" class="menu-item">
                    <a>RENEWAL</a>

                    <ul class="sub-menu">
                        <li *hasPermission="['ClaimData', 'View']">
                            <a href="/claim-data">Claim Data</a>
                        </li>
                        <li *hasPermission="['PerformanceData', 'View']">
                            <a href="/performance">Performance Data</a>
                        </li>
                        <li *hasPermission="['PremiumData', 'View']">
                            <a href="/premium-data">Premium Data</a>
                        </li>
                        <li *hasPermission="['RenewalReports', 'View']">
                            <a href="/renewal-report-selection">Renewal Reports</a>
                        </li>
                    </ul>
                </li>

                <li *ngIf="menuPermissions.showPowerBi || false" class="menu-item">
                    <a>POWER BI</a>

                    <ul class="sub-menu">
                        <li>
                            <a href="/powerbi-report">Reports</a>
                        </li>
                        <li>
                            <a href="/powerbi-dashboard">Dashboard</a>
                        </li>
                    </ul>
                </li>

                <li *ngIf="menuPermissions.showAdministration || false" class="menu-item">
                    <a>ADMINISTRATION</a>

                    <ul class="sub-menu">
                        <li *hasPermission="['Auditing', 'View']">
                            <a href="/audit-log">Audit Logs</a>
                        </li>
                        <li *hasPermission="['Client', 'View']">
                            <a href="/client">Clients</a>
                        </li>
                        <li *hasPermission="['ExchangeRate', 'View']">
                            <a href="/exchange-rate">Exchange Rates</a>
                        </li>
                        <li *hasPermission="['PolicyGroup', 'View']">
                            <a href="/policy-group">Policy Groups</a>
                        </li>
                        <li *ngIf="false"> <!-- NVISION ACCESS ONLY: *hasPermission="['Tenant', 'View']" -->
                            <a href="/tenant">Tenants (nVision)</a>
                        </li>
                        <li *hasPermission="['User', 'View']">
                            <a href="/user">Users</a>
                        </li>
                        <li *ngIf="false"> <!-- NVISION ACCESS ONLY: *hasPermission="['Role', 'View']" -->
                            <a href="/user-role">Roles (nVision)</a>
                        </li>
                        <li *hasPermission="['AdminReports', 'View']">
                            <a href="/user-report">User Report</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </nav>
    </div>
</div>

<tenant-selection-panel *ngIf="showTenantPanel" [tenants]="tenants" (tenantSelected)="onTenantSelected($event)" (tenantModalClosed)="closeModal()"></tenant-selection-panel>